import PanAnimation from "../../../logic/PanAnimation";
import Projection from "../../../Projection";
import Page from "../../framework/Page";
import View from "../../framework/View";
import { PageIds } from "../../PageIds";

export default class CenterButtonView extends View {
    /**
     * @param {string} parentId
     * @param {Projection} projection
     * @param {PanAnimation} panAnimation 
     */
    constructor(parentId, projection, panAnimation) {
        super(parentId, PageIds.CENTER_ON_CHARACTER_BUTTON);

        /**
         * @constant
         * @type {Projection}
         */
        this.projection = projection;

        /**
         * @constant
         * @type {PanAnimation}
         */
        this.panAnimation = panAnimation;

        // Hide the button by default at the start.
        this.setInitialVisibility(false);

    }

    /**
     * @override
     * @inheritdoc
     */
    initializeView() {

        // const buttonElement = Page.getElement(PageIds.CENTER_ON_CHARACTER_BUTTON);
        // if (!buttonElement) {
        //     console.log('CenterButtonView.initializeView() Failed to find button id: ' + PageIds.CENTER_ON_CHARACTER_BUTTON);
        //     return;
        // }

        // <div id="centerOnCharacterButton" class="center-on-character-button" style="display:none;">
        //   <img src="images/ui_center_button.png" title="Center on Crew"/>
        // </div>

        const parentElement = Page.getElement(this.parentId);
        const buttonElement = Page.createElement('div', parentElement, this.elementId, 'center-on-character-button');

        buttonElement.style.display = 'none';

        const imageElement = Page.createElement('img', buttonElement, null, null);
        imageElement.src = 'images/ui_center_button.png';
        imageElement.title = 'Center on Crew';


        const thisRef = this;
        buttonElement.onclick = function() {
            thisRef.panAnimation.startAnimation();
        };

        super.initializeView();
    }

    /**
     * @override
     */
    updateView() {
        const visible = !this.projection.stayCenteredOnCharacter && !this.panAnimation.animating;

        if (visible !== this.isViewVisible()) {
            this.setViewVisible(visible);
        }

        // The parent class takes care of showing and hiding stuff.
        super.updateView();
    }

}